import Loading from './src/directive';
import LoadingService from './src/index'

module.exports = {
    Loading,LoadingService
}


// WEBPACK FOOTER //
// ./src/components/loading/index.js